import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';

export const DICE_RANGE_LIMIT_OPTIONS = {
  min: 1,
  max: 99,
  minValueBetween: 0,
};

export const RANGE_TYPE = {
  Under: 0,
  Over: 1,
};

export const MARKET_TYPE = {
  0: 'UNDER',
  1: 'OVER',
};

export const DEFAULT_RANGE_VALUE = 50;
export const DICE_MULTIPLIER_PRECISION = 4;
export const DICE_WIN_CHANCE_PRECISION = 6;
export const DICE_ROLL_PRECISION = 0;
export const DICE_WIN_CHANCE_STEP_VALUE = 1;
export const DICE_MULTIPLIER_STEP_VALUE = 3;

export const DEFAULT_MULTIPLIER_LIMITS = {
  minBet: 1.0101,
  maxBet: 97,
};

export const DICE_FORMULA_LIMIT = {
  minBet: 1.01,
  maxBet: 100,
};

export const DICE_GAME_ID = 41;

export const DiceLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: 'bombCount',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => (
      <span className='cpt-table-text'>
        {t(MARKET_TYPE[spinInfo.spinData.spinMarket])} {spinInfo.spinData.number}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const DiceBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: '',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => (
      <span className='cpt-table-text'>
        {t(MARKET_TYPE[spinInfo.spinMarket])} {spinInfo.number}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const DiceSoundsName = {
  win: 'win',
  bet: 'bet',
  increase: 'increase',
  toggle: 'toggle',
};

export const DiceSoundsPath = [
  {
    src: 'audio/dice/bet.mp3',
    name: DiceSoundsName.bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/dice/win.mp3',
    name: DiceSoundsName.win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/dice/toggle.mp3',
    name: DiceSoundsName.toggle,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/dice/increase.mp3',
    name: DiceSoundsName.increase,
    autoplay: false,
    html5: true,
  },
];

export const DICE_RULES_KEYS = new Array(isPG() ? 16 : 12)
  .fill(null)
  .map((item, index) => index + 1);
export const DICE_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
